@if (isLoadingSiteLocations) {
  <div class="form-field">
    <mat-progress-spinner class="h-12 w-12" mode="indeterminate" />
  </div>
} @else {
  @if (shouldHandleOccupiedDoors) {
    @if (allLocations$ | async; as locations) {
      <app-autocomplete
        class="form-field"
        [aria]="ariaLabel"
        [form]="form"
        [controlName]="controlName"
        valueProperty="id"
        [options]="locations"
        [requireSelection]="true"
        [displayProperties]="['label']"
        [label]="label">
      </app-autocomplete>
    }
  } @else if (isLocationsHierarchyEnabled) {
    @if (allLocations$ | async; as locations) {
      <app-autocomplete
        class="form-field"
        [aria]="ariaLabel"
        [form]="form"
        [controlName]="controlName"
        valueProperty="id"
        [options]="locations"
        [requireSelection]="true"
        [displayProperties]="['label']"
        [label]="label">
      </app-autocomplete>
    }
  } @else {
    <app-input-autocomplete
      class="form-field"
      [aria]="ariaLabel"
      [labelKey]="label"
      [controlName]="controlName"
      [form]="form"
      [items]="filteredLocations" />
  }
}
